import {
    enableProdMode,
    importProvidersFrom,
    provideZoneChangeDetection,
} from "@angular/core";
import { environment } from "@env/environment";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { APP_ROUTES } from "@app/app.routes";
import { CoreModule } from "@app/core/core.module";
import { SharedModule } from "@app/shared/shared.module";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SettingsModule } from "@app/core/settings/settings.module";

import { DialogModule } from "@app/shared/dialog/dialog.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { IonicModule } from "@ionic/angular";
import { AppComponent } from "@app/app.component";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

// Add tenant styles
const tenantStyles = document.createElement("link");
tenantStyles.setAttribute("rel", "stylesheet");
tenantStyles.setAttribute("type", "text/css");
tenantStyles.setAttribute("href", environment.apiEndpoint + "tenant-styles");

document.head.appendChild(tenantStyles);

if (environment.production || environment.envName === "TEST") {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(APP_ROUTES, withComponentInputBinding()),
        importProvidersFrom(
            BrowserModule,
            // core & shared
            CoreModule,
            SharedModule,
            // settings (NgRx state)
            SettingsModule,
            // dialog
            DialogModule,
            // translations
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            // ionic
            IonicModule.forRoot()
        ),
        provideAnimations(),
    ],
});
